<template>
    <nav class="navbar navbar-expand-md navbar-primary navbar-light mx-auto pt-md-4 mb-md-4 px-md-2 col-lg-10 py-0"
         :class="{ 'navbar-drop': showAdminBar }">
        <div class="container-fluid main-wrapper d-flex justify-content-between">
            <a class="navbar-brand skin-navbar-brand" target="_blank" :href="parentCompanyLink"
               :style="parentCompanyLink === '' ? 'pointer-events: none;' : ''">
                <span class="visually-hidden">Guiide</span>
            </a>

            <button class="navbar-toggler border-0 fs-6" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
                    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div v-if="showTitle" class="d-none d-xl-block">
                <h1>{{ title }}</h1>
            </div>

            <div class="collapse navbar-collapse d-md-flexjustify-content-md-end" id="navbarText">
                <ul class="navbar-nav mb-2 mb-lg-0" style="margin-right:6.5px;">
                    <li class="nav-item">
                        <a class="nav-link" :href="homeResource" :class="{ active: homeActive }">Home</a>
                    </li>

                    <li v-if="showStart" class="nav-item">
                        <a class="nav-link" :class="{ disabled: !startEnabled, active: startActive }" href="/home/userhome">Start</a>
                    </li>

                    <li v-if="showDesign" class="nav-item">
                        <a class="nav-link" :class="{ disabled: !designEnabled, active: designActive }"
                           href="/home/startdesign">Design</a>
                    </li>

                    <li v-if="showTrack" class="nav-item">
                        <a class="nav-link" :class="{ disabled: !trackEnabled, active: trackActive }" :href="trackResource">Track</a>
                    </li>

                    <li v-if="showPlan" class="nav-item">
                        <a class="nav-link" :class="{ disabled: !planEnabled, active: planActive }" href="/finish">Plan</a>
                    </li>

                    <li v-if="showLogin" class="nav-item">
                        <a class="nav-link" :class="{ disabled: false, active: false }" :href="loginResource">Log In</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script lang="ts">
import { isAdminUser, normalizeResourcePath } from "@/guiide/ts/utilities";
import View from "@/guiide/ts/view";
import { defineComponent } from "vue";

export default defineComponent({
    name: "TopBar",
    computed: {
        isInWorkflow: function (): boolean {
            const workflowViews = [
                View.UserHome,
                View.You,
                View.Requirements,
                View.Haves,
                View.Life,
                View.Design,
                View.Test,
                View.Finish,
                View.Secure
            ];
            return (
                workflowViews.filter(wv => wv == this.$store.state.view).length > 0
            );
        },
        showAdminBar: function (): boolean {
            return isAdminUser();
        },
        parentCompanyLink: function () {
            return this.$store.state.configuration.parentCompanyLink;
        },
        title: function (): string {
            return this.$store.state.configuration.title;
        },
        showTitle: function (): boolean {
            return this.$store.state.configuration.displayTitleInWorkflow;
        },
        showTrack: function () {
            return (
                this.isInWorkflow && this.$store.state.configuration.nav.track.available
            );
        },
        trackEnabled: function () {
            if (this.$store.state.retiree == null) {
                return false;
            }

            if (this.$store.state.configuration.finishDisplaysNextButton) {
                return true;
            }

            return this.$store.state.retiree.isRegistered;
        },
        trackResource: function () {
            return normalizeResourcePath(this.$store.state.configuration.nav.track.resource);
        },
        showPlan: function () {
            return !this.isInWorkflow;
        },
        planEnabled: function () {
            return !this.isInWorkflow;
        },
        homeResource: function () {
            return normalizeResourcePath(this.$store.state.configuration.nav.home.resource);
        },
        showStart: function () {
            return (
                this.isInWorkflow && this.$store.state.configuration.nav.start.available
            );
        },
        startEnabled: function () {
            return true;
        },
        showDesign: function () {
            return (
                this.isInWorkflow &&
                this.$store.state.configuration.nav.design.available
            );
        },
        designEnabled: function () {
            return true;
        },
        trackActive: function () {
            return false;
        },
        planActive: function () {
            return false;
        },
        homeActive: function () {
            return false;
        },
        startActive: function () {
            return false;
        },
        designActive: function () {
            return this.showStart;
        },
        showLogin: function () {
            return this.isInWorkflow && this.$store.state.configuration.nav.login.available;
        },
        loginActive: function () {
            return true;
        },
        loginResource: function () {
            return normalizeResourcePath(this.$store.state.configuration.nav.login.resource);
        }
    }
});
</script>

<style scoped>
    .navbar-collapse {
        flex-grow: 0;
    }

    @media (max-width: 767px) {
        .navbar-collapse {
            flex-grow: 1;
        }
    }

    nav {
        border-bottom: 1px;
    }

    @media (min-width: 1200px) {
        nav {
            height: 106px;
        }
    }

    @media (max-width: 768px) {
        .navbar-brand {
            margin-top: 0;
            margin-left: 3px !important;
        }
    }

    @media (max-width: 768px) {
        .navbar-primary {
            border-bottom: 1px solid #ccc;
        }
    }

    .pt-md-4 {
        padding-top: var(--navbar-padding-top) !important;
    }

    .navbar-brand {
        padding: 0;
        background-repeat: no-repeat;
    }

    .navbar-drop {
        margin-top: 82px;
    }

    .nav-link {
        border: none;
        margin: 12px;
        padding: 10px 18px;
        line-height: 1.5;
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        border-bottom: 2px solid transparent;
    }

        .nav-link:hover,
        .nav-link.active {
            border-bottom: 2px solid var(--primary-color);
        }
</style>
